import React, { useState,useEffect } from "react";
import "./productform.css";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const ProductForm = () => {
  const navigate = useNavigate();
  const [preview, setPreview] = useState(
    "https://cdn-icons-png.flaticon.com/512/10446/10446694.png"
  );
  const [categories, setCategories] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [file, setFile] = useState(null);

  const [formData, setFormData] = useState({
    product_title: "",
    category_id: "",
    description: "",
  });
useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch("https://hind-eng.serverscripts.in/api/v1/category/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      if (response.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      if (result.success) setCategories(result.data);
      else toast.error(result.message);
    } catch {
      toast.error("Failed to fetch categories");
    }
  };
  const loadFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setFile(file);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    const data = new FormData();
    data.append("product_title", formData.product_title);
    data.append("category_id", formData.category_id);
    data.append("description", formData.description);

    if (file) {
      data.append("image", file); 
    }

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch("https://hind-eng.serverscripts.in/api/v1/product/add", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });
      
      const result = await res.json();
      
      console.log(result);
      if (res.status === 401) {
        toast.error("Session expired, please log in again");
        localStorage.removeItem("authToken");
        navigate('/login');
        return;
      }
      if (result.success) {
        setProcessing(false);
        toast.success("Product added successfully!");
        navigate(`/product-details`);
      } else {
        setProcessing(false);
        toast.error("Failed to add product: " + (result.message || ""));
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error submitting product form.");
    }
  };
  const handleDescriptionChange = (e) => {
  const value = e.target.value;
  const words = value.trim().split(/\s+/).filter(w => w.length > 0);

  if (words.length > 60) {
    return; 
  }

  setFormData({
    ...formData,
    description: value
  });
};


  return (
    <div className="product-form">
      <h2>Add Product</h2>
      <form className="form-section" onSubmit={handleSubmit}>
        <div className="card left-section">
          <div className="image-section">
            <label htmlFor="fileSelect">
              <img src={preview} alt="Preview" className="image-preview" />
            </label>
            <input
              type="file"
              id="fileSelect"
              className="hidden"
              accept="image/*"
              onChange={loadFile}
            />
          </div>

          <div className="input-section">
            <div className="form-group">
              <label className="form-label">Product Title</label>
              <input
                type="text"
                name="product_title"
                className="form-input"
                value={formData.product_title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Select Category</label>
              <select
                name="category_id"
                className="form-input"
                value={formData.category_id}
                onChange={handleChange}
                required
              >

                <option value="">-- Select Category --</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Description (Minimum & Maximum 60 words)</label>

              <textarea
                name="description"
                className="form-input textarea"
                value={formData.description}
                onChange={handleDescriptionChange}
                required
              ></textarea>

              
              <p style={{ fontSize: "12px", marginTop: "5px" }}>
                Words: {formData.description.trim() === "" 
                  ? 0 
                  : formData.description.trim().split(/\s+/).length} / 60
              </p> 
            </div>

            <div className="button-row">
              <button type="submit" className="product-save-button">
                {processing ? "Saving...." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;
